import { render } from "./Twitter.vue?vue&type=template&id=b967894c"
import script from "./Twitter.vue?vue&type=script&lang=js"
export * from "./Twitter.vue?vue&type=script&lang=js"
script.render = render

export default script